export const COUNTRYANDSTATE_LOADING = 'REDUX_SAGA_COUNTRYANDSTATE_LOADING';
export const GET_COUNTRYANDSTATE_DATA_SUCCESS = 'REDUX_SAGA_GET_COUNTRYANDSTATE_DATA_SUCCESS';
export const GET_COUNTRYANDSTATE_DATA_ERROR = 'REDUX_SAGA_GET_COUNTRYANDSTATE_DATA_ERROR';
export const COUNTRYANDSTATE_END_LOADING = 'REDUX_SAGA_COUNTRYANDSTATE_END_LOADING';
export const RESET_COUNTRYANDSTATE = 'REDUX_SAGA_RESET_COUNTRYANDSTATE';

export const actionGetCountryAndState = (dispatch) => {
    dispatch({ type: COUNTRYANDSTATE_LOADING})
};

export const actionResetCountryAndState = (dispatch) => {
    dispatch({ type: RESET_COUNTRYANDSTATE })
}




